<template>
  <header class="stats-header">
    <h5 v-if="currentMetric === METRICS.TIME_ABOVE_80_PERCENT_HR">
      <img src="@/assets/images/activity/hr-icon.png" alt="metric" />
      {{ $t('DASHBOARD.statsHeader.hr')}}
    </h5>
    <h5 v-if="currentMetric === SESSION_METRICS.AP || currentMetric === METRICS.AP_PERCENTAGE">
      <img src="@/assets/images/activity/active-participation-icon.png" alt="metric" />
      {{ $t('DASHBOARD.statsHeader.ap')}}
    </h5>
    <h5 v-if="currentMetric === METRICS.DISTANCE">
      <img src="@/assets/images/activity/distance-speed-icon.png" alt="metric" />
      {{ $t('DASHBOARD.statsHeader.distance')}}
    </h5>
    <h5 v-if="currentMetric === METRICS.WORKLOAD">
      <img src="@/assets/images/activity/workload-icon.png" alt="metric" />
      {{ $t('DASHBOARD.statsHeader.workload')}}
    </h5>

    <div class="legend fa-pull-right" v-if="!displayGameType">
      <div class="legend-item">
        <span class="circle empty"></span>
        {{ $t('DASHBOARD.statsHeader.trainingOther')}}
      </div>

      <div class="legend-item">
        <span class="circle full"></span>
        {{ $t('DASHBOARD.statsHeader.game')}}
      </div>

      <div class="legend-item">
        <span class="circle gridlines"></span>
        {{ $t('DASHBOARD.statsHeader.mixed')}}
      </div>

      <div class="legend-item">
        <span class="circle empty white-border"></span>
        {{ $t('DASHBOARD.statsHeader.individual')}}
      </div>
    </div>
  </header>
</template>

<script>
import { METRICS } from '@/constants/DashboardConstants';
import { SESSION_METRICS } from '@/constants/SessionConsts';

export default {
  name: 'StatsHeader',
  props: {
    currentMetric: String,
    displayGameType : Boolean
  },
  data () {
    return {
      METRICS: METRICS,
      SESSION_METRICS: SESSION_METRICS
    }
  }
}
</script>

<style lang="scss" scoped>
  .stats-header {
    display: inline-block;
    width: 100%;
    color: $mid-gray;
    margin-top: 40px;

    h5 {
      font-weight: 700;
      font-size: 14px;
      display: inline-block;

      img {
        margin-right: 10px;
      }
    }

    .stats-img {
      margin-right: 10px;
    }

    .metric {
      display: none;
    }

    .legend {
      .legend-item {
        display: inline-block;
        margin-left: 20px;
        font-size: 14px;

        &:first-child {
          margin-left: 0;
        }

        .circle {
          display: inline-block;
          width: 13px;
          height: 13px;
          background-color: $mid-gray;
          border-radius: 50%;
          position: relative;
          top: 2px;
          margin-right: 2px;

          &.empty {
            background-color: $wood-smoke;
            border: 1px solid $mid-gray;
          }

          &.gridlines {
            background: #c3c3c3;
          }

          &.empty.white-border {
            border: 1px solid $white;
          }
        }
      }
    }
  }
</style>


